import analytics from "web/script/analytics/analytics";

type PerformanceMetricsSerializer = {
    initial_navigation: Record<string, any>;
    third_party: any[];
} & {
    [key: string]: any[] | any;
};

export function getPerformanceMetrics(): PerformanceMetricsSerializer {
    const performanceEntries = performance.getEntries();
    const metrics: PerformanceMetricsSerializer = {
        initial_navigation: {},
        third_party: [],
    };

    for (let i = 0; i < performanceEntries.length; i++) {
        const entry = performanceEntries[i];

        switch (entry.constructor.name) {
            case "PerformanceNavigationTiming": {
                metrics.initial_navigation = (entry as PerformanceNavigationTiming).toJSON();

                break;
            }
            case "PerformancePaintTiming": {
                const key = entry.name.replace(/-/g, "_");

                metrics[key] = (entry as PerformancePaintTiming).toJSON();

                break;
            }
            case "PerformanceResourceTiming": {
                const initiatorType = (entry as PerformanceResourceTiming).initiatorType.replace(
                    /-/g,
                    "_"
                );

                // eslint-disable-next-line max-depth
                if (metrics[initiatorType]) {
                    (metrics[initiatorType] as PerformanceResourceTiming[]).push(entry.toJSON());
                } else {
                    metrics[initiatorType] = [entry.toJSON()];
                }

                break;
            }
            case "PerformanceMark": {
                metrics.third_party.push((entry as PerformanceMark).toJSON());

                break;
            }
            default: {
                break;
            }
        }
    }

    return metrics;
}

export function sendPerformanceMetrics(page: string): boolean {
    const metrics = getPerformanceMetrics();
    const payload = analytics._addMetaData(metrics);
    payload["_type"] = "performance_metrics";
    payload["_version"] = "1.0.0";
    payload["_source"] = `lyst_web.frontend.performance_metrics.${page}`;
    const dataBlob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    return navigator.sendBeacon("/rest_api/frontend_performance_metrics/", dataBlob);
}
